export type PartnerState = {
  currentPartner?: Partner
}

export type Partner = {
  id: string
  name: string
}

export const initialPartnerState = {
  currentPartner: undefined
}
